module.exports = __webpack_public_path__ + "img/wdyb-icon.c3307ade.png";